




	import Vue from "vue";

	export default Vue.extend({
        props: ['order']
	})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/backend/components/table/fields/ItemsField.vue